import Page from '../../components/PageWrapper';
import { useEffect, useMemo, useState } from 'react';
import {
  GetRelationshipManagerMetrics,
  getAllTeams,
  getRelationshipManager,
  getRelationshipManagerTeams
} from '../../api/requests';
import Loader from '../../components/Loader';
import InviteTeamMember from './InviteTeamMemberModal';
import { Link, useNavigate, useParams } from 'react-router-dom';
import AssignMember from './assignMemberModal';
import useUserAccount from '../../hooks/userAccountHook';
import { User } from '../../models/User';
import AssignRelationshipManager from './AssignRelationshipMagerModal';
import SetCommission from './SetCommission';
import useRoute from '../../hooks/routesHook';
import { EllipsisVerticalIcon } from '@heroicons/react/24/outline';
import PopOnMe from '../../components/elements/poponme';
import { Staff } from '../../models/staff/Staff';
import DoughnutChart from '../../components/dashboard/charts/DonutChart';
import DashboardTabs from '../../components/dashboard/tabs/DashboardTabs';
import { PopOver } from '../../components/elements/PopOver';
import { RiInformationFill } from 'react-icons/ri';
import RelationshipManagerDetailsModal from './RelationshipManagerDetailsModal';
import { LeadsDonutBgColors, SalesMixDonutsBgColors } from '../../resources/constants';
import DashboardDatePickers, {
  SelectedDateRange
} from '../../components/dashboard/date-range-selector/datePicker';
import useModal from '../../hooks/modalHook';
import BackButton from '../../components/BackButton';
import {
  IAdminSalesMetrics,
  ITeamLeadMetrics,
  ITeamManagingSalesMetrics
} from '../../models/generalMetrics/IGeneralMetrics';
import GTable from '../../components/elements/GTable';
import TabContent from '../../components/tabs/TabContent';
import TabNav, { ITab } from '../../components/tabs/TabNav';
import CreateTask from '../admin/leads/CreateTask';
import clsx from 'clsx';
import moment from 'moment';
import { GTableActionColumn, ITableRowAction } from '../../components/elements/GTable/GTable';
import { ITask } from '../../resources/interfaces';
import { capitalizeSentence, getFormattedLeadSource, getInstallmentTypeFromKey, getPhoneNumberFromShortCodeFormat, getPolicyReviewStatus, getVehicleProtectionFromKey, numberWithCommas } from '../../utils/miscFunctions';
import { getStatus } from '../shared/policies/auto/policyDetails';
import PolicyStatus from '../../components/elements/PolicyStatus';
import { Policy } from '../../models/policy/Policy';
import { LEAD_STATUS, POLICY_STATUS_OPTIONS } from '../../resources/enums';
import { useSelector } from 'react-redux';
import { getSelectedCountry } from '../../states/slices/resourceSlice';

export interface IDisableAdmin {
  id: string;
}

function RelationshipManagerTeam(): JSX.Element {

  //  states
  const [relationshipManager, setRelationshipManager] = useState<Staff>();
  const [loading, setLoading] = useState<boolean>();
  const [teams, setTeams] = useState<any>();
  const [activeTab, setActiveTab] = useState('teams');
  const [selectedDateRange, setSelectedDateRange] = useState<SelectedDateRange>({
    from: '',
    to: ''
  });
  const [showTeamDetailsModal, setShowTeamDetailsModal] = useState<boolean>(false);
  const selectedCountry = useSelector(getSelectedCountry);
  const countryId = selectedCountry?.id ?? 1
  const [relationshipManagerMetrics, setRelationshipManagerMetrics] = useState<IAdminSalesMetrics>({
    due_later: {
      amount: {
        total: 0,
        third_party: 0,
        comprehensive: 0
      },
      count: {
        total: 0,
        third_party: 0,
        comprehensive: 0
      }
    },
    due_now: {
      amount: {
        total: 0,
        third_party: 0,
        comprehensive: 0
      },
      count: {
        total: 0,
        third_party: 0,
        comprehensive: 0
      }
    },
    lead: {
      channel: {
        whatsapp: 0,
        referral: 0,
        facebook: 0,
        direct: 0,
        telegram: 0,
        google: 0,
        instagram: 0,
        radio: 0
      },
      status: {
        warm: 0,
        paid: 0,
        closed: 0,
        cold: 0
      },

    },
    signups: [],
    policies: [],
    tasks: [],
  });
  const [salesMix, setSalesMix] = useState({
    due_now: {
      amount: {
        Comprehensive: 0,
        'Third Party': 0
      },
      count: {
        Comprehensive: 0,
        'Third Party': 0
      }
    },
    due_later: {
      amount: {
        Comprehensive: 0,
        'Third Party': 0
      },
      count: {
        Comprehensive: 0,
        'Third Party': 0
      }
    }
  });
  const [managedTeamSalesMix, setManagedTeamSalesMix] = useState<ITeamManagingSalesMetrics>({
    due_later: {
      amount: {
        total: 0,
        third_party: 0,
        comprehensive: 0
      },
      count: {
        total: 0,
        third_party: 0,
        comprehensive: 0
      }
    },
    due_now: {
      amount: {
        total: 0,
        third_party: 0,
        comprehensive: 0
      },
      count: {
        total: 0,
        third_party: 0,
        comprehensive: 0
      }
    },
    lead: {
      channel: {
        whatsapp: 0,
        referral: 0,
        facebook: 0,
        direct: 0,
        telegram: 0,
        google: 0,
        instagram: 0,
        radio: 0
      },
      status: {
        warm: 0,
        paid: 0,
        closed: 0,
        cold: 0
      }
    }
  });


  // Hooks
  const { ModalComponent, updateModalStates, closeModal } = useModal();
  const navigate = useNavigate();
  const { getDashboardBase } = useRoute();
  const { getProfile } = useUserAccount();
  const user = new User(getProfile());
  const { managerId } = useParams();
  const id = managerId;



  useEffect(() => {
    if (relationshipManagerMetrics) {
      setSalesMix({
        ...salesMix,
        due_now: {
          amount: {
            Comprehensive: relationshipManagerMetrics.due_now.amount.comprehensive,
            'Third Party': relationshipManagerMetrics.due_now.amount.third_party
          },
          count: {
            Comprehensive: relationshipManagerMetrics.due_now.count.comprehensive,
            'Third Party': relationshipManagerMetrics.due_now.count.third_party
          }
        },
        due_later: {
          amount: {
            Comprehensive: relationshipManagerMetrics.due_later.amount.comprehensive,
            'Third Party': relationshipManagerMetrics.due_later.amount.third_party
          },
          count: {
            Comprehensive: relationshipManagerMetrics.due_later.count.comprehensive,
            'Third Party': relationshipManagerMetrics.due_later.count.third_party
          }
        }
      });
    }
  }, [relationshipManagerMetrics]);

  useEffect(() => {
    setLoading(true);
    if (id) getRelationshipManagerDetails(id);
  }, []);

  useEffect(() => {
    if (id) getTeams(id);
  }, []);

  useEffect(() => {
    if (id) getAdminMetrics(id);
  }, [selectedDateRange, countryId]);


  // Actions
  const handleDateChange = (dateRange: { from: string; to: string }) => {
    setSelectedDateRange(dateRange);
  };

  const inviteMember = () => {
    updateModalStates({
      show: true,
      size: 'md',
      children: (
        <InviteTeamMember
          onProceed={() => {
            closeModal();
          }}
          onClose={closeModal}
        />
      ),
      
      classes: '!p-0 r-[5px]'
    });
  };

  const getSingleTeamActions = (row: any) => {
    const id = row?.id;
    const singleTeamActions = [];

    if (user.isInternalOwner()) {
      singleTeamActions.push(
        {
          label: 'Set Relationship Manager',
          callback: () => {
            assignRelationshipManager(id);
          }
        },
        {
          label: 'Set commission rate',
          callback: () => {
            SetCommissionPercentage(id);
          }
        },
        {
          label: 'Add member to team',
          callback: () => {
            assignMember(id);
          }
        },
        {
          label: 'Invite member',
          callback: () => {
            inviteMember();
          }
        }
      );
    }

    return singleTeamActions;
  };

  const assignRelationshipManager = (id: string) => {
    updateModalStates({
      show: true,
      size: 'md',
      children: (
        <AssignRelationshipManager
          teamID={id}
          onProceed={() => {
            closeModal();
            getAllTeams();
          }}
          onClose={closeModal}
        />
      ),
      
      classes: '!p-0 r-[5px]'
    });
  };

  const showCreateTaskModal = (task?: ITask,) => {
    id && updateModalStates({
      show: true,
      size: 'xl',
      children: (
        <CreateTask
          onProceed={() => {
            // id && fetchCustomer(id)
            closeModal();
          }}
          onClose={closeModal}
          id={id}
          isEdit={false}
          task={task}
          type={'CUSTOMER'} />
      ),
      
      classes: '!p-0 r-[5px]'
    });
  };

  const showUpdateTaskModal = (task?: ITask) => {
    id && updateModalStates({
      show: true,
      size: 'xl',
      children: (
        <CreateTask
          onProceed={() => {
            // id && fetchCustomer(id)
            closeModal();
          }}
          onClose={closeModal}
          id={id}
          isEdit={true}
          task={task}
          type={'CUSTOMER'} />
      ),
      
      classes: '!p-0 r-[5px]'
    });
  };

  const getAdminMetrics = (id: string) => {
    GetRelationshipManagerMetrics(countryId, id, selectedDateRange)
      .then((response: any) => {
        setRelationshipManagerMetrics(response);
      })
      .catch((error: Error) => { })
      .finally(() => {
        setLoading(false);
      });
  };

  const getTeams = (id: string) => {
    getRelationshipManagerTeams(id)
      .then((response: any) => {
        setTeams(response?.data);
      })
      .catch((error: Error) => { })
      .finally(() => {
        // setLoading(false);
      });
  };

  const getRelationshipManagerDetails = (id: string) => {
    getRelationshipManager(id)
      .then((response: any) => {
        setRelationshipManager(response);
      })
      .catch((error: Error) => { })
      .finally(() => {
        setLoading(false);
      });
  };

  const assignMember = (id: string) => {
    updateModalStates({
      show: true,
      size: 'md',
      children: (
        <AssignMember
          teamID={id}
          onProceed={() => {
            closeModal();
            getAllTeams();
          }}
          onClose={closeModal}
        />
      ),
      
      classes: '!p-0 r-[5px]'
    });
  };
  const handleTabClicked = (id: string) => {
    // navigate(`${getDashboardBase()}/approvals?tab=${id}`);
  };

  const getTaskTableRowActions = (data: any): ITableRowAction[] => {
    const actions = [
      {
        label: 'Update',
        callback: (task: any) => showUpdateTaskModal(task),
        data: data
      }
    ];

    return actions;
  };

  const SetCommissionPercentage = (id: string) => {
    updateModalStates({
      show: true,
      size: 'sm',
      children: (
        <SetCommission
          onProceed={() => {
            closeModal();
            getAllTeams();
          }}
          onClose={closeModal}
          teamID={id}
        />
      ),
      
      classes: '!p-0 r-[5px]'
    });
  };

  const getAdminTabs = () => {
    let tabs: ITab[] = [
      {
        id: "teams",
        title: "Teams",
        // itemCount: customer && customer?.tasks && customer?.tasks?.length
      },
      {
        id: "tasks",
        title: "Tasks",
        // itemCount: customer && customer?.tasks && customer?.tasks?.length
      },
      {
        id: "signups",
        title: "Signups",
        // itemCount: customer && customer?.policyList && customer?.policyList?.length
      }, {
        id: "policies",
        title: "Policies",
        // itemCount: customer && customer?.policyList && customer?.policyList?.length
      },
    ]

    return tabs
  }
  const getAdminTeamsTabs = () => {
    let tabs: ITab[] = [
      {
        id: "signups",
        title: "Signups",
        // itemCount: customer && customer?.policyList && customer?.policyList?.length
      }, {
        id: "policies",
        title: "Policies",
        // itemCount: customer && customer?.policyList && customer?.policyList?.length
      }, {
        id: "customers",
        title: "Customers",
        // itemCount: customer && customer?.policyList && customer?.policyList?.length
      },
    ]

    return tabs
  }

  const fullName = `${relationshipManager?.firstName} 
  ${relationshipManager?.lastName}
  `;

  // Columns
  const taskColumns = useMemo(
    () => [
      {
        Header: 'M',
        columns: [
          {
            Header: 'Name',
            accessor: 'name',
            Cell: (row: any) => {
              return <span>{row.cell.value ? capitalizeSentence(row.cell.value) : '-'}</span>;
            }
          },

          {
            Header: 'Description',
            accessor: 'description',
            Cell: (row: any) => {
              return <span>{row.cell.value ?? '-'}</span>;
            }
          },
          {
            Header: 'Type',
            accessor: 'type',
            Cell: (row: any) => {
              return <span>{row.cell.value ?? '-'}</span>;
            }
          },
          {
            Header: 'Assigned To',
            accessor: 'assignedTo.firstName',
            Cell: (row: any) => {
              return (
                <span>
                  {row.cell.value
                    ? capitalizeSentence(
                      row.row.original.assignedTo.firstName +
                      ' ' +
                      row.row.original.assignedTo.lastName
                    )
                    : '-'}
                </span>
              );
            }
          },
          {
            Header: 'Status',
            accessor: 'completed',
            Cell: (row: any) => {
              return getStatus(row.cell.value);
            }
          },
          {
            Header: 'Due date',
            accessor: 'dueOn',
            Cell: (row: any) => {
              return (
                <span>
                  {row.cell.value ? moment(row.cell.value).format('MMM Do YY, h:mm a') : '-'}
                </span>
              );
            }
          },
          {
            id: 'Action',
            Cell: (row: any) => {
              return (
                <div className="cursor-pointer flex justify-center">
                  {getTaskTableRowActions(row.row.original).length > 0 && (
                    <PopOnMe actions={getTaskTableRowActions(row.row.original)}>
                      <EllipsisVerticalIcon className="h-4 w-4" />
                    </PopOnMe>
                  )}
                </div>
              );
            }
          }
        ]
      }
    ],
    []
  );

  const columns = useMemo(
    () => [
      {
        Header: 'M',
        columns: [
          {
            Header: 'Name',
            accessor: 'name',
            Cell: (row: any) => {
              return <span>{row.cell.value ? row.cell.value : '-'}</span>;
            }
          },
          {
            Header: 'Type',
            accessor: 'type',
            Cell: (row: any) => {
              return <span>{row.cell.value ? row.cell.value : '-'}</span>;
            }
          },
          {
            Header: 'No of Members',
            accessor: 'numberOfMembers',
            Cell: (row: any) => {
              return <span>{row.cell.value ? row.cell.value : '-'}</span>;
            }
          },
          {
            Header: 'Relationship Manager',
            accessor: 'relationshipManager',
            Cell: (row: any) => {
              return (
                <span>
                  {row.cell.value
                    ? `${row.cell.value.firstName} ${row.cell.value.lastName}`
                    : '-'}
                </span>
              );
            }
          },
          {
            Header: 'Admin',
            accessor: 'teamLead',
            Cell: (row: any) => {
              return <span>{row.cell.value ? row.cell.value : '-'}</span>;
            }
          },
          {
            id: 'Action',
            Header: 'Actions',
            Cell: (row: any) => {
              if(getSingleTeamActions(row.row.original).length > 0) return (
                <GTableActionColumn actions={getSingleTeamActions(row.row.original)}/>
              );
            }
          }
        ]
      }
    ],
    []
  );

  const policyolumns = useMemo(
    () => [
      {
        Header: 'M',
        columns: [
          {
            Header: 'Customer',
            accessor: 'customer',
            Cell: (row: any) => {
              return (
                <span>
                  {row.cell.value
                    ? `${row.cell.value?.firstName} ${row.cell.value?.lastName}`
                    : '-'}
                </span>
              );
            }
          },
          {
            Header: 'Phone #',
            accessor: 'customer.phone',
            Cell: (row: any) => {
              return <span>{getPhoneNumberFromShortCodeFormat(row.cell.value) ?? '-'}</span>;
            }
          },
          {
            Header: 'Policy ID',
            accessor: 'policyNumber',
            Cell: (row: any) => {
              //  to={`${getDashboardBase()}/policies/${
              //   row?.row?.original.ref
              // }?filter=${filter}&page=${currentPage}`}>

              return (
                <Link to={`${getDashboardBase()}/policies/${row.cell.value}`}>
                  <span className="hover:underline text-link-main dark:text-darkBg-textLink dark:hover:text-darkBg-textLink">{row.cell.value ?? '-'}</span>
                </Link>
              );
            }
          },
          {
            Header: 'Status',
            accessor: 'reviewStage',
            Cell: (row: any) => {
              return (
                (
                  <PolicyStatus
                    status={getPolicyReviewStatus(row.cell.value)}
                    firstSuccessfulPayment={row?.original?.isInitialPaymentReceived()}
                  />
                )
              );
            }
          },
          {
            Header: 'Protection Type',
            accessor: 'quote.protectionType',
            Cell: (row: any) => {
              return (
                <span>
                  {row.cell.value ? getVehicleProtectionFromKey(row.cell.value)?.title : '-'}
                </span>
              );
            }
          },
          // {
          //   Header: 'Installment Type',
          //   accessor: 'installmentType',
          //   Cell: (row: any) => {
          //     return (
          //       <span>
          //         {row.cell.value ? <>{getInstallmentTypeFromKey(row.cell.value)}</> : '-'}
          //       </span>
          //     );
          //   }
          // },
          {
            Header: 'Premium',
            accessor: 'quote.paymentPlan.outRightPremium',
            Cell: (row: any) => {
              return (
                <div className="min-w-[100px]">
                  <span>GHS {numberWithCommas(row.cell.value)}</span>{' '}
                </div>
              );
            }
          },
          // {
          //   Header: 'Initial Deposit',
          //   accessor: 'quote.paymentPlan.initialDeposit',
          //   Cell: (row: any) => {
          //     return (
          //       <div className="min-w-[100px]">
          //         <span> GHS {numberWithCommas(row.cell.value)}</span>
          //       </div>
          //     );
          //   }
          // },
          // {
          //   Header: 'Installments',
          //   accessor: 'quote.paymentPlan.monthlyInstallment',
          //   Cell: (row: any) => {
          //     return (
          //       <div className="min-w-[100px]">
          //         <span>
          //           {row.cell.value ? (
          //             <>
          //               <span>GHS</span> {numberWithCommas(row.cell.value)}
          //             </>
          //           ) : (
          //             '-'
          //           )}
          //         </span>
          //       </div>
          //     );
          //   }
          // },
          {
            Header: 'Total Payment',
            accessor: 'quote.paymentPlan.totalPremium',
            Cell: (row: any) => {
              return (
                <div className="min-w-[100px]">
                  <span>
                    {' '}
                    {row.cell.value ? (
                      <>
                        <span>GHS</span> {numberWithCommas(row.cell.value)}
                      </>
                    ) : (
                      '-'
                    )}
                  </span>
                </div>
              );
            }
          },
          {
            Header: 'Inception Date',
            accessor: 'startsOn',
            Cell: (row: any) => {
              return (
                <span>
                  {row.cell.value ? moment(row.cell.value).format('DD/MM/YY h:mm a') : '-'}
                </span>
              );
            }
          },
          {
            Header: 'Insurer',
            accessor: 'insurer',
            Cell: (row: any) => {
              return <span>{row.cell.value ? row.cell.value?.name : '-'}</span>;
            }
          },
          {
            Header: 'Owner',
            accessor: 'owner',
            Cell: (row: any) => {
              return <span>{row.cell.value ? row.cell.value?.name : '-'}</span>;
            }
          },
          {
            Header: 'Manager',
            accessor: 'manager',
            Cell: (row: any) => {
              return (
                <span>
                  {row.cell.value
                    ? `${row.cell.value?.firstName} ${row.cell.value?.lastName}`
                    : '-'}
                </span>
              );
            }
          },
          {
            Header: 'Created On',
            accessor: 'createdOn',
            Cell: (row: any) => {
              return (
                <span>
                  {row.cell.value ? moment(row.cell.value).format('DD/MM/YY h:mm a') : '-'}
                </span>
              );
            }
          },
          // {
          //   Header: 'Status',
          //   accessor: 'status',
          //   Cell: (row: any) => {
          //     return (
          //       <div className="w-full flex  text-white">
          //         <span
          //           className={clsx(
          //             'w-[30px] h-[30px] rounded-full flex items-center justify-center text-[0px] ',
          //             {
          //               ['bg-status-active']:
          //                 new Policy(row.row.original).getStatus()?.toLowerCase() ===
          //                 POLICY_STATUS_OPTIONS.ACTIVE
          //             },
          //             {
          //               ['bg-status-ended']:
          //                 new Policy(row.row.original).getStatus()?.toLowerCase() ===
          //                 POLICY_STATUS_OPTIONS.INACTIVE
          //             }
          //           )}>
          //           {new Policy(row.row.original).getStatus()}
          //         </span>
          //       </div>
          //     );
          //   }
          // },
        ]
      }
    ],
    []
  );

  const signupColumns = useMemo(
    () => [
      
      {
        Header: 'M',
        columns: [
          {
            Header: 'Name',
            accessor: 'firstname',
            Cell: (row: any) => {
              return (
                <span>
                  {row.cell.value ? (
                    <>
                      {capitalizeSentence(
                        row.row.original.firstname + ' ' + row.row.original.lastname
                      )}
                    </>
                  ) : (
                    '-'
                  )}
                </span>
              );
            }
          },

          {
            Header: 'Phone',
            accessor: 'phone',
            Cell: (row: any) => {
              return (
                <span>
                  {row.cell.value ? getPhoneNumberFromShortCodeFormat(row.cell.value) : '-'}
                </span>
              );
            }
          },
          {
            Header: 'Status',
            accessor: 'leadStatus',
            Cell: (row: any) => {
              return (
                <PolicyStatus
                  status={capitalizeSentence(row.cell.value ?? LEAD_STATUS.COLD)}
                  classes="!w-[80px]"
                />
              );
            }
          },
          {
            Header: 'Source',
            accessor: 'leadSource',
            Cell: (row: any) => {
              return <span>{row.cell.value ? getFormattedLeadSource(row.cell.value) : '-'}</span>;
            }
          },
          {
            Header: 'Current Insurer',
            accessor: 'currentInsurer',
            Cell: (row: any) => {
              return <span>{row.cell.value ? row.cell.value : '-'}</span>;
            }
          },
          {
            Header: 'Insurance Type',
            accessor: 'insuranceType',
            Cell: (row: any) => {
              return (
                <span>
                  {row.cell.value ? getVehicleProtectionFromKey(row.cell.value)?.title : '-'}
                </span>
              );
            }
          },
          {
            Header: 'Expiry Date',
            accessor: 'expiryDate',
            Cell: (row: any) => {
              return (
                <span>{row.cell.value ? moment(row.cell.value).format('DD/MM/YYYY') : '-'}</span>
              );
            }
          },
          {
            Header: 'Owner',
            accessor: 'owner.firstName',
            Cell: (row: any) => {
              return (
                <span>
                  {row.cell.value ? (
                    <>
                      {row.row.original.owner.firstName.charAt(0).toUpperCase() +
                        row.row.original.owner.firstName.slice(1)}{' '}
                      {row.row.original.owner.lastName.charAt(0).toUpperCase() +
                        row.row.original.owner.lastName.slice(1)}
                    </>
                  ) : (
                    '-'
                  )}
                </span>
              );
            }
          },
          {
            Header: 'Created On',
            accessor: 'createdOn',
            Cell: (row: any) => {
              return (
                <span>{row.cell.value ? moment(row.cell.value).format('DD/MM/YYYY') : '-'}</span>
              );
            }
          },
        ]
      }
    ],
    []
  );

  return (
    <Page title="Admin Teams">
      <div className="bg-white w-full p-5  rounded-2xl shadow-md dark:bg-darkBg dark:border dark:border-darkBg-border">
        <div className="flex  items-center gap-4 justify-between">
          <div className="flex items-center gap-4">
            <BackButton onClick={() => navigate(-1)} />
            {relationshipManager && (
              <div className="flex gap-x-5 items-center justify-center">
                <div className="">
                  <h2 className="font-semibold text-sm md:text-xl dark:text-darkBg-mainText">{`${fullName}'s Performance`}</h2>
                </div>

                <div className="shrink-0">
                  {relationshipManager && (
                    <PopOver
                      size="sm"
                      trigger={<RiInformationFill className="h-6 w-6 cursor-pointer outline-0 dark:text-darkBg-mainText" />}
                      show={showTeamDetailsModal}>
                      {<RelationshipManagerDetailsModal />}
                    </PopOver>
                  )}
                </div>
              </div>
            )}
          </div>

          <div className="p-5">
            <DashboardDatePickers
              onSubmit={(data: SelectedDateRange) => {
                handleDateChange(data);
              }}
            />
          </div>
        </div>

        <div className=" p-2 rounded-[5px]">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  gap-6 xl:gap-10 mt-8 mb-8">
            <div className="  rounded-md overflow-hidden  p-4 sm:p-12 md:p-4 lg:p-4 xl:p-5 border border-primary-border">
              <DashboardTabs
                tabGroupTitle="Due Now Sales"
                tab1={{
                  name: 'Amount',
                  children: (
                    <DoughnutChart
                      chartKey={'amount'}
                      displayAsCurrency
                      metricsData={salesMix.due_now.amount}
                      bgColors={SalesMixDonutsBgColors}
                      required
                    />
                  )
                }}
                tab2={{
                  name: 'Count',
                  children: (
                    <DoughnutChart
                      chartKey={'count'}
                      metricsData={salesMix.due_now.count}
                      bgColors={SalesMixDonutsBgColors}
                      required
                    />
                  )
                }}
              />
            </div>
            <div className="border border-primary-border rounded-md overflow-hidden  p-4 sm:p-12 md:p-4 lg:p-4 xl:p-5 ">
              <DashboardTabs
                tabGroupTitle="Due Later Sales"
                tab1={{
                  name: 'Amount',
                  children: (
                    <DoughnutChart
                      chartKey={'amount'}
                      displayAsCurrency
                      metricsData={salesMix.due_later.amount}
                      bgColors={SalesMixDonutsBgColors}
                      required
                    />
                  )
                }}
                tab2={{
                  name: 'Count',
                  children: (
                    <DoughnutChart
                      chartKey={'count'}
                      metricsData={salesMix.due_later.count}
                      bgColors={SalesMixDonutsBgColors}
                      required
                    />
                  )
                }}
              />
            </div>
            <div className="  rounded-md overflow-hidden  p-4 sm:p-12 md:p-4 lg:p-4 xl:p-5 border border-primary-border">
              <DashboardTabs
                tabGroupTitle="Leads"
                tab1={{
                  name: 'Channel',
                  children: (
                    <DoughnutChart
                      chartKey={'lead_channel'}
                      metricsData={relationshipManagerMetrics.lead.channel}
                      bgColors={LeadsDonutBgColors}
                      required
                    />
                  )
                }}
                tab2={{
                  name: 'Status',
                  children: (
                    <DoughnutChart
                      chartKey={'leads_status'}
                      metricsData={relationshipManagerMetrics.lead.status}
                      bgColors={LeadsDonutBgColors}
                      required
                    />
                  )
                }}
              />
            </div>
          </div>

          <div className="mt-10">
            {loading ? (
              <div className=" flex items-center justify-center">
                <Loader message="Loading. Please wait..." brollyLoader />
              </div>
            ) : (
              <div className="overflow-x-auto ">
                <TabNav
                  tabs={getAdminTabs()}
                  activeTab={activeTab}
                  onTabClicked={handleTabClicked}
                  setActiveTab={(id: string) => {
                    setActiveTab(id)
                  }}
                />

                <TabContent id={'teams'} activeTab={activeTab}>
                  {teams && teams.length > 0 ? (
                    <div className=" my-5 ">
                      <GTable
                        columns={columns}
                        data={teams}
                        tableType={'team'}
                        showSearch={false}
                        classes="h-fit"
                      />
                    </div>
                  ) :
                    <div className="h-20 flex items-center justify-center text-lg dark:text-darkBg-mainText">No team found </div>
                  }
                </TabContent>


                <TabContent id={'tasks'} activeTab={activeTab}>
                  {relationshipManagerMetrics &&
                    relationshipManagerMetrics.tasks &&
                    relationshipManagerMetrics.tasks.length > 0 ? (
                    <div className=" my-5 ">
                      <GTable
                        columns={taskColumns}
                        data={relationshipManagerMetrics?.tasks}
                        classes="h-fit"
                        showSearch={false}
                        tableType={'task'}
                        stickyHeader
                      />
                    </div>
                  ) :
                    <div className="h-20 flex items-center justify-center text-lg dark:text-darkBg-mainText">No task found </div>
                  }
                </TabContent>

                <TabContent id={'signups'} activeTab={activeTab}>
                  {relationshipManagerMetrics &&
                    relationshipManagerMetrics.signups &&
                    relationshipManagerMetrics.signups.length > 0
                    ? (
                      <div className=" my-5 ">
                        <GTable
                          columns={signupColumns}
                          data={relationshipManagerMetrics?.signups}
                          classes="h-fit"
                          showSearch={false}
                          tableType={'signup'}
                          stickyHeader
                        />
                      </div>
                    ) :
                    <div className="h-20 flex items-center justify-center text-lg dark:text-darkBg-mainText">No signup found </div>
                  }
                </TabContent>

                <TabContent id={'policies'} activeTab={activeTab}>
                  {relationshipManagerMetrics?.policies && relationshipManagerMetrics?.policies.length > 0 ? (

                    <div className=" my-5 ">
                      <GTable
                        columns={policyolumns}
                        data={relationshipManagerMetrics?.policies}
                        showSearch={false}
                        tableType="policy"
                        onRowClick={(policy: Policy) => {
                          navigate(`${getDashboardBase()}/policies/${policy.ref}`, {
                            replace: true
                          });
                        }}
                        columnClasses={clsx('w-fit')}
                        loading={loading}
                        tableContainerId="tableId"
                        stickyHeader
                      />
                    </div>
                  ) : (
                    <div className="h-40 flex items-center justify-center text-lg dark:text-darkBg-mainText">
                      No policy found
                    </div>
                  )}
                </TabContent>
              </div>
            )}
          </div>
        </div>
      </div>
      <ModalComponent />
    </Page>
  );
}

export default RelationshipManagerTeam;
